import { useState } from 'react';

import { ImageSection } from '../ImageSectionController.interface';

export const useImageSectionController = ({
  customer,
  handleOnChange,
}: ImageSection) => {
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  const handleOpenBackgroundDrawer = (index: number) => {
    setCurrentIndex(index);
    setOpenBackgroundDrawer(true);
  };

  const handleCloseBackgroundDrawer = () => {
    setCurrentIndex(null);
    setOpenBackgroundDrawer(false);
  };

  const addNewImage = (field: {
    value: any;
    onChange: (value: any[]) => void;
  }) => {
    handleOpenBackgroundDrawer((field.value || []).length);
  };

  const replaceImage = (index: number) => {
    handleOpenBackgroundDrawer(index);
  };

  const removeImage = (
    index: number,
    field: { value: any; onChange: (value: any[]) => void },
  ) => {
    const updatedMedia = field.value.filter((_: any, i: number) => i !== index);
    handleOnChange(`${customer}.media`, updatedMedia, field.onChange);
  };

  return {
    currentIndex,
    addNewImage,
    replaceImage,
    removeImage,
    openBackgroundDrawer,
    handleCloseBackgroundDrawer,
  };
};
